<template>
  <div class="projects-list">
    <a class="projects-list__back" href="#" @click.prevent.stop="handleClick">
      <span>Back</span>
    </a>
    <div class="projects-list__introduction">
      <ContentText
        v-if="category.text"
        :content="category.text"
      />
    </div>
    <ul class="projects-list__items">
      <li class="projects-list__item"
        v-for="(item, i) in category.items"
        :key="`item-${i}`"
      >
        <!-- <router-link
          class="projects-list__item__container"
          :to="{ name: 'project', params: { projectId: project.name } }"
          @mouseover.native="handleMouseOver(project.id)"
          @mouseout.native="handleMouseOut">
          <span class="projects-list__item__title">{{ project.title }}</span>
          <div class="projects-list__item__label">{{ project.label }}</div>
        </router-link> -->
        <div class="projects-list__item__container">
          <span class="projects-list__item__title" v-html="item.title" />
          <div class="projects-list__item__label" v-html="item.label" />
          <ul class="projects-list__item__list" v-if="item.subitems">
            <li
              class="projects-list__item__subitem"
              v-for="(subitem, j) in item.subitems"
              :key="`subitem-${i}-${j}`"
            >
              <div class="projects-list__item__label" v-html="subitem.label" />
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ContentText from './ContentText'

export default {
  name: 'TheProjectsList',
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  components: {
    ContentText
  },
  methods: {
    ...mapActions({
      updateCurrentPicture: 'common/updateCurrentPicture'
    }),
    ...mapActions('page', [
      'updateCategoryIndex'
    ]),
    handleClick () {
      this.$emit('back')
      this.updateCategoryIndex(0)
    },
    handleMouseOver (id) {
      this.updateCurrentPicture(id)
    },
    handleMouseOut () {
      this.updateCurrentPicture(0)
    }
  }
}
</script>

<style lang="scss">
.projects-list{
  width: 100%;

  // Back

  &__back{
    @include add-transition;
    @include icon(icons("arrow-left"));
    @include hover{
      color: rgba(white, 1);
    }
    display: inline-block;
    text-decoration: none;
    font-size: 3.5rem;
    color: rgba(white, 0.3);
    position: relative;
    transform: translateY(-1rem);

    span{
      @include hide-visually;
    }
  }

  // Introduction

  &__introduction{
    margin-bottom: layout("spacing")*1.5;
  }

  // Items

  &__items{
    @include no-type-list;
  }

  // Item

  &__item{
    @include media("small"){
      font-size: 1.6rem;
    }
    @include media("medium-large"){
      font-size: 1.8rem;
    }

    padding-bottom: 2.5rem;
    color: white;

    // Container

    &__container{
      margin: 0;
      display: inline-block;
      font-size: 2.5rem;
      font-family: get($font-families, 'secondary');
      color: rgba(white, 1);
      text-decoration: none;

       a{
        @include add-transition;
        @include media("large"){
          @include add-hover-underline;
        }
        @include hover{
          color: rgba(white, 1);
        }

        color: rgba(white, 0.3);
      }
    }

    // Title

    &__title{
      @include subtitle;

      font-family: get($font-families, 'secondary');

      display: block;
      margin: 0;
    }

    // Label

    &__label{
      @include label;
      margin-top: 1rem;
    }

    // List

    &__list{
      @include no-type-list;
      margin-top: layout("spacing")/2;

      .projects-list__item__label{
        font-size: 1.1rem;
        font-style: italic;
      }
    }
  }
}
</style>
